import {
  AdminVendorFilter,
  GoogleLinkReview,
  VendorVerification,
} from "generated/graphql";
import { AdminTab } from "./types";

export const PAGE_SIZE = 25;
export const SEARCH_DEBOUNCE_MS = 300;

export const ADMIN_TABS: { label: string; path: AdminTab }[] = [
  { label: "Analytics", path: "analytics" },
  { label: "Vendors", path: "vendors" },
  { label: "Expiring Documents", path: "expiring" },
  { label: "Users", path: "users" },
  { label: "Support", path: "support" },
];

export const VENDOR_FILTER_LABELS: Record<AdminVendorFilter, string> = {
  [AdminVendorFilter.All]: "All vendors",
  [AdminVendorFilter.PendingGoogle]: "Google link to review",
  [AdminVendorFilter.Pending]: "Awaiting review",
  [AdminVendorFilter.Approved]: "Approved",
  [AdminVendorFilter.Rejected]: "Rejected",
  [AdminVendorFilter.NeedsReverification]: "Changes to review",
  [AdminVendorFilter.Paused]: "Paused",
  [AdminVendorFilter.Suspended]: "Suspended",
};

export const GOOGLE_REVIEW_LABELS: Record<GoogleLinkReview, string> = {
  [GoogleLinkReview.Approved]: "Approved",
  [GoogleLinkReview.PendingReview]: "Waiting for review",
  [GoogleLinkReview.Rejected]: "Rejected",
};

export const VERIFICATION_LABELS: Record<VendorVerification, string> = {
  [VendorVerification.Pending]: "Awaiting review",
  [VendorVerification.Approved]: "Approved",
  [VendorVerification.Rejected]: "Rejected",
};

export const VERIFICATION_COLORS: Record<VendorVerification, string> = {
  [VendorVerification.Pending]: "#ed6c02",
  [VendorVerification.Approved]: "#2e7d32",
  [VendorVerification.Rejected]: "#d32f2f",
};
